import React, { useEffect, useState } from 'react';
import FormPage from '../../../../../shared/Layout/FormPage';
import CustomCard, { CustomGridLayout } from '../../../../../shared/Cards/CustomCard';
import { CustomCalenderInput, CustomDropDown, CustomInput } from '../../../../../shared/Input/AllInputs';
import formValidation from '../../../../../utils/validations';
import CustomTabInput from '../../../../../shared/Input/CustomTabInput';
import { useSelector } from 'react-redux';
import PrimaryButton, { CustomButton } from '../../../../../shared/Button/CustomButton';
import CustomTabGroup from '../../../../../shared/TabView/CustomTabGroup';
import useDepartments from '../../../../../hooks/Employees/useDepartments';
import useEmployees from '../../../../../hooks/Employees/useEmployees';
import { conditionDropdowns, genderOptions, yesNoOptions } from '../../../../../utils/dropdownConstants';
import useCommissionGroup from '../../../../../hooks/Inventory/useCommissionGroup';
import CustomPickList from '../../../../../shared/Input/CustomPickList';
import useProfitCenters from '../../../../../hooks/Inventory/useProfitCenters';
import {
    agreementDataPoints,
    commissionsDataPoints,
    employeeEventsDataPoints,
    employeeResourcesDataPoints,
    employeeTasksDataPoints,
    eventDataPoints,
    inventoryDataPoints,
    purchasedProductDataPoints,
    purchasedServiceDataPoints,
    resourcesDataPoints,
    rewardsDataPoints,
    tasksDataPoints,
    timesheetsDataPoints,
    userIndexDataPoints,
} from '../../../../../utils/reportDataPoints';
import PurchasedServices from './PurchasedServices';

export default function RuleForm({ onCancel, onRuleSave, rule }) {
    const [activeTimePeriodIndex, setActiveTimePeriodIndex] = useState(0);

    let userTypeOptions = [
        { name: 'Member', value: 'MEMBER' },
        { name: 'Employee', value: 'EMPLOYEE' },
    ];
    let employeeOptions = [
        { name: 'Timesheets', value: 'TIMESHEETS' },
        { name: 'Events', value: 'EMPLOYEE_EVENTS' },
        { name: 'Commissions', value: 'COMMISSIONS' },
        { name: 'Tasks', value: 'EMPLOYEE_TASKS' },
        { name: 'Resources', value: 'EMPLOYEE_RESOURCES' },
        { name: 'Inventory', value: 'INVENTORY' },
    ];
    let memberOptions = [
        { name: 'Purchased Service', value: 'PURCHASED_SERVICES' },
        { name: 'Purchased Product', value: 'PURCHASED_PRODUCT' },
        { name: 'Agreement', value: 'AGREEMENT' },
        { name: 'Event', value: 'EVENT' },
        { name: 'Rewards', value: 'REWARDS' },
        { name: 'Tasks', value: 'TASKS' },
        { name: 'Resources', value: 'RESOURCES' },
        { name: 'User Index', value: 'USER_INDEX' },
    ];

    const [data, setData] = useState({
        userType: 'MEMBER',
        ruleType: memberOptions?.value,
    });

    const handleChange = ({ name, value }) => {
        const formErrors = formValidation(name, value, data);
        setData((prev) => ({ ...prev, [name]: value, formErrors }));
    };

    let { clubsDropdown } = useSelector((state) => state.settings.business);
    const agreementCategoryDropdown = useSelector((state) => state.settings.agreement.agreementCategoryDropdown);
    const { campaignDropdown } = useSelector((state) => state.settings.members);
    const { eventCategories, eventsDropDown } = useSelector((state) => state.settings.schedule);

    let { departmentsDropdown } = useDepartments();
    let { employeesDropdown } = useEmployees();
    let { commissionGroupDropdown } = useCommissionGroup();

    const { profitCenterDropdown } = useProfitCenters();

    useEffect(() => {
        if (data.userType) {
            setData((prev) => ({
                ...prev,
                ruleType: data.userType === 'MEMBER' ? 'PURCHASED_SERVICES' : 'TIMESHEETS',
            }));
        }
    }, [data.userType]);

    const statusOptions = [
        { name: 'Abandoned Cart', value: 'ABANDONED_CART' },
        { name: 'Pending', value: 'PENDING' },
        { name: 'Active', value: 'ACTIVE' },
        { name: 'Expired', value: 'EXPIRED' },
        { name: 'Cancelled', value: 'CANCELLED' },
    ];

    const billingOptions = [
        { name: 'Good Standing', value: 'GOOD_STANDING' },
        { name: 'Declined', value: 'DECLINED' },
        { name: 'Past Due', value: 'PAST_DUE' },
        { name: 'Collection', value: 'COLLECTION' },
    ];

    const eventStatusOptions = [
        { name: 'Booked', value: 'BOOKED' },
        { name: 'Completed', value: 'COMLETED' },
        { name: 'Attended', value: 'ATTENDED' },
        { name: 'Cancelled Charge', value: 'CANCELLED_CHARGE' },
        { name: 'Cancelled No Charge', value: 'CANCELLED_NO_CHARGE' },
    ];

    const eventStatusForEmployeeOptions = [
        { name: 'Completed', value: 'COMLETED' },
        { name: 'Pending', value: 'PENDING' },
        {
            name: 'Attended',
            value: 'ATTENDED',
        },
        {
            name: 'Unattended',
            value: 'UNATTENDED',
        },
    ];

    const onSave = () => {
        onRuleSave(data);
    };

    const getSourceDataForPickList = (ruleType) => {
        switch (ruleType) {
            case 'PURCHASED_SERVICES':
                return purchasedServiceDataPoints;
            case 'PURCHASED_PRODUCT':
                return purchasedProductDataPoints;
            case 'AGREEMENT':
                return agreementDataPoints;
            case 'EVENT':
                return eventDataPoints;
            case 'REWARDS':
                return rewardsDataPoints;
            case 'TASKS':
                return tasksDataPoints;
            case 'RESOURCES':
                return resourcesDataPoints;
            case 'USER_INDEX':
                return userIndexDataPoints;
            case 'TIMESHEETS':
                return timesheetsDataPoints;
            case 'EMPLOYEE_EVENTS':
                return employeeEventsDataPoints;
            case 'COMMISSIONS':
                return commissionsDataPoints;
            case 'INVENTORY':
                return inventoryDataPoints;
            case 'EMPLOYEE_TASKS':
                return employeeTasksDataPoints;
            case 'EMPLOYEE_RESOURCES':
                return employeeResourcesDataPoints;
            default:
                return [];
        }
    };

    return (
        <FormPage backText="Rules" onClickBack={onCancel}>
            <CustomCard
                col="12"
                title="Custom Rule"
                extraCard={
                    <>
                        <CustomTabInput className="mt-2" data={data} onChange={handleChange} name="userType" options={userTypeOptions} />
                        <CustomTabInput
                            className="mt-2"
                            data={data}
                            onChange={handleChange}
                            name="ruleType"
                            options={data.userType === 'MEMBER' ? memberOptions : employeeOptions}
                        />
                    </>
                }
            >
                <div className="flex flex-column gap-3 p-2">
                    {data?.ruleType === 'PURCHASED_SERVICES' && (
                        <>
                            <PurchasedServices onChange={handleChange} />
                        </>
                    )}
                </div>
            </CustomCard>
            <div className="flex justify-content-end gap-3 w-full mt-3">
                <PrimaryButton label="Save" onClick={() => onSave(data)} />
                <CustomButton label="Cancel" onClick={onCancel} />
            </div>
        </FormPage>
    );
}
